import { motion } from "framer-motion";

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`line-mask ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeIn = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const LotusMark = ({ className = "w-6 h-6 text-gold" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" className={className}>
    <path d="M12 3c1.8 2.2 2.6 4.4 2.6 6.4S13.4 13 12 13s-2.6-1.6-2.6-3.6S10.2 5.2 12 3z" />
    <path d="M4.5 8.5c2.6.4 4.6 1.6 5.8 3.3" />
    <path d="M19.5 8.5c-2.6.4-4.6 1.6-5.8 3.3" />
    <path d="M2 14c2.8 3.6 6.2 5.4 10 5.4S19.2 17.6 22 14c-2 .8-4 1.2-6 1.2-1.6 0-3-.3-4-.9-1 .6-2.4.9-4 .9-2 0-4-.4-6-1.2z" />
  </svg>
);
